<template>
  <div class="container">
    <!-- <img class="toplogo" src="@/assets/img2/logo-white.png" /> -->
    <div class="ruleicon" @click="rulePopupShow = true">规则</div>
    <img class="dlicon" @click="dlFn" src="@/assets/img2/venuetwo-dl.png" />

    <div class="top">
      <div class="li">
        <img class="icon" src="@/assets/img2/venueone-icon1.png" />
        <div class="right">{{ num1 }}</div>
      </div>
      <div class="li">
        <img class="icon" src="@/assets/img2/popup-hd2.png" />
        <div class="right">{{ num2 }}</div>
      </div>
      <div class="li">
        <img class="icon" src="@/assets/img2/venuetwo-icon1.png" />
        <div class="right">{{ num3 }}</div>
      </div>
    </div>

    <img class="fdkh" src="@/assets/img2/venuetwo-zqcg.png" />
    <img class="fdkhtime" src="@/assets/img2/venueone-fdkhtime.png" />

    <div class="tabs">
      <div :class="['tab', activeTab == 'jkzs' ? 'tabactive' : '']" @click="activeTab = 'jkzs'">
        <img class="textimg" v-if="activeTab == 'jkzs'" src="@/assets/img2/venuetwo-jkzsdt-active.png" />
        <img class="textimg" v-else src="@/assets/img2/venuetwo-jkzsdt.png" />
      </div>
      <div :class="['tab', activeTab == 'jkxw' ? 'tabactive' : '']" @click="activeTab = 'jkxw'">
        <img class="textimg" v-if="activeTab == 'jkxw'" src="@/assets/img2/venuetwo-jkxwdk-active.png" />
        <img class="textimg" v-else src="@/assets/img2/venuetwo-jkxwdk.png" />
      </div>
    </div>

    <div class="jkzsbox" v-if="activeTab == 'jkzs'">
      <div class="jkzs-top">
        <div>答对题数：<span class="span1">{{ ddts }}</span></div>
        <div>答题进度：<span class="span1">{{ dtjd }}</span> <span class="span2">/ 3</span></div>
      </div>
      <div class="content">
        <div class="beginbox" v-if="dtStatus == 0">
          <img class="jkzsdttitle" src="@/assets/img2/venuetwo-jkzsdt-title.png" />
          <div class="tips">
            <div class="text">1.每日 3 道健康 / 保险知识题</div>
            <div class="text">2.全部答对可获积分+智慧之星徽章 1 枚</div>
            <div class="text">3.答错可查看正确答案，次日可重新答题</div>
          </div>
          <div class="btn" @click="dtStatus = 1; dtjd = 1">开始答题</div>
        </div>
        <div class="quesbox" v-if="dtStatus == 1">
          <div class="ques">1、{{ quesList[dtjd - 1].ques }}</div>
          <template v-if="quesList[dtjd - 1].quesShow">
            <div class="answerbox">
              <div @click="answerClick('A')" :class="['an-item', getQueClass('A')]">
                <div class="opt">A：{{ quesList[dtjd - 1].A }}</div>
                <van-icon :name="getQueClass('A', 'icon')" class="icon" />
              </div>
              <div @click="answerClick('B')" :class="['an-item', getQueClass('B')]">
                <div class="opt">B：{{ quesList[dtjd - 1].B }}</div>
                <van-icon :name="getQueClass('B', 'icon')" class="icon" />
              </div>
              <div @click="answerClick('C')" :class="['an-item', getQueClass('C')]">
                <div class="opt">C：{{ quesList[dtjd - 1].C }}</div>
                <van-icon :name="getQueClass('C', 'icon')" class="icon" />
              </div>
              <div @click="answerClick('D')" :class="['an-item', getQueClass('D')]">
                <div class="opt">D：{{ quesList[dtjd - 1].D }}</div>
                <van-icon :name="getQueClass('D', 'icon')" class="icon" />
              </div>
            </div>
            <div class="answerbtn" v-show="quesList[dtjd - 1].dtjg">
              <div class="btn btn1" @click="quesList[dtjd - 1].quesShow = false">答案解析</div>
              <div class="btn btn2" v-if="dtjd == 3" @click="dtSubmit">提交</div>
              <div class="btn btn2" v-else @click="dtjd++">下一题</div>
            </div>
          </template>
          <template v-else>
            <div class="analybox">
              <div class="analybox-con">
                <div class="text1">答案</div>
                <div class="text2">正确答案：
                  <span>{{ quesList[dtjd - 1].correct }}、{{ quesList[dtjd - 1][quesList[dtjd - 1].correct] }}</span>
                </div>
                <div class="text1">解析</div>
                <div class="text2">{{ quesList[dtjd - 1].analy }}</div>
              </div>
              <div class="back" @click="quesList[dtjd - 1].quesShow = true">返回答题</div>
            </div>
          </template>
        </div>
        <div class="beginbox resultbox" v-if="dtStatus == 2">
          <template v-if="dtAllright">
            <div class="title">太棒啦，全答对了！<br />恭喜获得：</div>
            <diV class="priceitem">
              <div class="item">
                <img class="icon" src="@/assets/img2/popup-hd2.png" />
                <div>+{{ dtjl.points }} 积分</div>
              </div>
              <div class="item">
                <img class="icon" :src="dtjl.hzimg" />
                <div>【{{ dtjl.hzname }}】</div>
              </div>
            </diV>
          </template>
          <template v-else>
            <img class="wzjicon" src="@/assets/img2/venuetwo-wzj.png" />
            <div class="title titlewzj">很遗憾，差一点就全答对了！明天再来试试吧！</div>
          </template>
          <div class="btn" @click="dtStatus = 3">我知道了</div>
        </div>
        <div class="beginbox endbox" v-if="dtStatus == 3">
          <img class="jkzsdttitle" src="@/assets/img2/venuetwo-jkzsdt-title.png" />
          <div class="tips">
            <div class="text">今日答题已完成，请明日再来哦~</div>
          </div>
          <div class="btn btn">开始答题</div>
        </div>
      </div>
    </div>

    <div class="jkxwbox" v-else>
      <div class="jkxw-top">
        <div class="line1">
          <img class="icon" src="@/assets/img2/venuetwo-jkzsxw-icon1.png" alt="">
          <div class="des">已坚持打卡 <span>0</span> 天</div>
          <img class="icon" src="@/assets/img2/venuetwo-jkzsxw-icon1.png" alt="">
        </div>
        <div class="line2">
          <div class="date">2026/05/18</div>
          <img class="icon" src="@/assets/img2/venuetwo-jkzsxw-icon3.png" alt="">
          <div class="week">第1周</div>
          <img class="icon" src="@/assets/img2/venuetwo-jkzsxw-icon4.png" alt="">
        </div>
      </div>
      <div class="clockbox">
        <div v-for="(item, i) in clockList" :key="i"
          :class="['clockitem', item.statu == 'ydk' ? ' clockitemydk' : item.statu == 'ddk' ? ' clockitemddk' : item.statu == 'seven' ? ' clockitemseven' : '']">
          <div class="jl" v-if="i == 1">3积分+徽章</div>
          <div class="jl jl2" v-if="i == 6">10积分+徽章</div>
          <template v-if="item.statu == 'ydk'">
            <img class="gift" src="@/assets/img2/venuetwo-gift.png" alt="">
            <div class="week">已打卡</div>
          </template>
          <template v-else-if="item.statu == 'ddk'">
            <img class="gift" src="@/assets/img2/venuetwo-gift.png" alt="">
            <div class="week">待打卡</div>
          </template>
          <template v-else-if="item.statu == 'seven'">
            <img class="gift" src="@/assets/img2/venuetwo-gift.png" alt="">
            <div class="week">{{ item.week }}</div>
          </template>
          <template v-else>
            <div class="date">{{ item.date }}</div>
            <div class="week">{{ item.week }}</div>
          </template>
        </div>

      </div>
      <div class="dkbox">
        <img class="jkxwtitle" src="@/assets/img2/venuetwo-jkxw-title.png" alt="">
        <div class="dkitem" @click="jkchose = 0">
          <img class="icon" src="@/assets/img2/venuetwo-jkxw-icon1.png" alt=""></img>
          <div class="name">运动打卡：每日步数≥6000 步</div>
          <van-icon class="check" name="checked" v-if="jkchose == 0" />
          <van-icon class="nocheck" name="circle" v-else />
        </div>
        <div class="dkitem dkitem2" @click="jkchose = 1">
          <img class="icon" src="@/assets/img2/venuetwo-jkxw-icon2.png" alt=""></img>
          <div class="name">喝水打卡：今日喝够 8 杯水</div>
          <van-icon class="check" name="checked" v-if="jkchose == 1" />
          <van-icon class="nocheck" name="circle" v-else />
        </div>
        <div class="dkitem dkitem3" @click="jkchose = 2">
          <img class="icon" src="@/assets/img2/venuetwo-jkxw-icon3.png" alt=""></img>
          <div class="name">早睡打卡：今晚 11 点前睡觉</div>
          <van-icon class="check" name="checked" v-if="jkchose == 2" />
          <van-icon class="nocheck" name="circle" v-else />
        </div>
        <div class="btn" v-if="jkStatus == 0" @click="ljdkFn">立即打卡</div>
        <div class="btn" v-else>今日已打卡</div>
      </div>
    </div>

    <common ref="commonComponent" />


    <!-- 结果弹框 -->
    <van-popup v-model="resultPopupShow" position="center" :close-on-click-overlay="false"
      class="custom-popup-jkresult">
      <div class="popupbg">
        <!-- 正面：徽章结果 -->
        <div class="popup-result card-front" :class="{ 'flipped': isFlipped }">
          <img class="titleimg" src="@/assets/img2/venuetwo-resulttitle.png" alt="">
          <img class="hzimg" :src="dtjl.hzimg" alt="">
          <div class="line"></div>
          <div class="des">完成一次答题（全对）</div>
          <div class="btnbox" @click="isFlipped = !isFlipped">
            <img class="fzicon" src="@/assets/img2/venuetwo-result-icon.png" alt="">
            <div>翻页有惊喜</div>
          </div>
        </div>

        <!-- 反面：产品结果 -->
        <div class="popup-result popup-result2 card-back" :class="{ 'flipped': isFlipped }">
          <div class="proName">{{ dtjl.proname }}</div>
          <div class="des2">{{ dtjl.prodesc }}</div>
          <div class="proimgbox">
            <img class="proimg" :src="dtjl.proimg" alt="">
            <div class="ljxg">立即选购</div>
          </div>
          <div class="pricebox">
            <span class="unit">￥</span><span class="price">{{ dtjl.proprice }}</span><span>元</span>
          </div>
          <div class="btnbox" @click="isFlipped = !isFlipped">
            <img class="fzicon" src="@/assets/img2/venuetwo-result-icon.png" alt="">
            <div>翻页看徽章</div>
          </div>
        </div>
        <van-icon name="close" class="popup-close" @click="resultPopupShow = false" />
      </div>
    </van-popup>

    <!-- 关注公众号 -->
    <van-popup v-model="gzhPopupShow" position="center" :close-on-click-overlay="false" class="custom-popup-gzh">
      <img class="topimg" src="@/assets/img2/home-popup-top.png" alt="">
      <div class="popup-content">
        <img class="titleimg" src="@/assets/img2/home-popup-title3.png" alt="">
        <img class="logo" src="@/assets/img2/logo.png" alt="">
        <img class="ewm" :src="gzhImg" alt="">
        <div class="des">（长按关注紫金保险官方公众号参与活动）</div>
      </div>
    </van-popup>

    <!-- 活动规则 -->
    <van-popup v-model="rulePopupShow" position="center" :close-on-click-overlay="false"
      class="custom-popup-gzh custom-popup-rule">
      <img class="topimg" src="@/assets/img2/home-popup-top.png" alt="">
      <div class="popup-content">
        <img class="titleimg" src="@/assets/img2/home-popup-title2.png" alt="">
        <div class="textbox">
          <div class="text">
            1.紫金保险会员每日登录可获得1次免费开福袋机会；
          </div>
          <div class="text">
            2.点击福袋，福袋打开，弹出对应奖品；
          </div>
          <div class="text">
            3.连续签到奖励：连续签到 3 天、7 天可额外获得 1 次开福袋机会;
          </div>
          <div class="text">
            4.分享奖励：分享活动给好友，好友参与后分享者额外获得 1 次机会
          </div>
        </div>
        <img class="btn" src="@/assets/img2/home-btn.png" alt="" @click="rulePopupShow = false">
      </div>
    </van-popup>
  </div>
</template>

<script>
import { dayQues, ansSubmit, getPersonApi, userPoints, zfLj, getActApi, postConfigApi, trackingMonitor, loginApi, shareApi } from '@/api/index'

import { getPageLlq, hzList } from '@/utils/index.js'
import common from './common.vue'
export default {
  components: { common },
  data() {
    return {
      rulePopupShow: false,
      gzhPopupShow: false,
      gzhImg: require('@/assets/img2/' + process.env.VUE_APP_ZKING_GZHIMG + '.png'),

      num1: 0,
      num2: 0,
      num3: 0,

      activeTab: 'jkzs',

      dtStatus: null,
      ddts: 0,
      dtjd: 0,
      dtAllright: null,
      dtjl: {},
      quesList: [
        // {
        //   id: 1, ques: '夏季养生，以下哪种做法更推荐？', A: '多喝冰水降温多喝冰水降温水', B: '多喝冰水降温', C: '多喝冰水降温', D: '多喝冰水降温',
        //   quesShow: true, correct: 'B', analy: '夏季养生，更推荐清淡饮食易消化，清热解暑（B)，冰水伤脾胃，反而不利散热（A），正午高温易中暑，耗气伤身（C），熬夜伤免疫，贪凉易受寒（D）。'
        // },
        // {
        //   id: 1, ques: '夏季养生22，以下哪种做法更推荐？', A: '多喝冰水降温多喝冰水降温水', B: '多喝冰水降温', C: '多喝冰水降温', D: '多喝冰水降温',
        //   quesShow: true, correct: 'B', analy: '夏季养生22，更推荐清淡饮食易消化，清热解暑（B)，冰水伤脾胃，反而不利散热（A），正午高温易中暑，耗气伤身（C），熬夜伤免疫，贪凉易受寒（D）。'
        // },
        // {
        //   id: 1, ques: '夏季养生33，以下哪种做法更推荐？', A: '多喝冰水降温多喝冰水降温水', B: '多喝冰水降温', C: '多喝冰水降温', D: '多喝冰水降温',
        //   quesShow: true, correct: 'B', analy: '夏季养生33，更推荐清淡饮食易消化，清热解暑（B)，冰水伤脾胃，反而不利散热（A），正午高温易中暑，耗气伤身（C），熬夜伤免疫，贪凉易受寒（D）。'
        // },
      ],

      jkStatus: 0,// 0未打卡，1已打卡
      clockList: [
        { date: 19, week: '周二', statu: 'ydk', desc: '3积分+徽章' },
        { date: 19, week: '周二', statu: 'ddk' },
        { date: 19, week: '周二', isToday: true },
        { date: 19, week: '周二' },
        { date: 19, week: '周二' },
        { date: 19, week: '周二' },
        { date: 19, week: '周日', statu: 'seven', desc: '10积分+徽章' },
      ],
      jkchose: null,

      resultPopupShow: false,//答题、运动打卡的 结果弹框
      resultObj: {},

      isFlipped: false, //控制翻转状态

      hzList: hzList,
    }
  },
  created() {
    console.log('venuetwo页面参数',this.$route.query);
    console.log('this.hzList', this.hzList);

    this.pageLlq = getPageLlq()
    // 判断链接中是否含有token
    if (this.$route.query.return_zking_info) {
      loginApi({ utoken: this.$route.query.return_zking_info }).then((res) => {
        console.log('xwede', res);

        localStorage.setItem('Authorization', res.data.accessToken)

        this.getPersonData()
        this.getQues()
      });
    } else {
      this.getPersonData()
      this.getQues()
    }


    // 初始判断 TODO
    // dtStatus的状态是什么
    // jkStatus的状态是什么
  },

  mounted() {
    window.addEventListener('resize', this.handleResize);
  },

  methods: {
    // 判断是否关注公众号
    getPersonData() {
      getPersonApi().then((res) => {
        if (res.code == 1006000000) {
          this.gzhPopupShow = true
        } else {
          this.gzhPopupShow = false
        }
        // this.zkToken = res.data.zkToken
      });
    },
    // 获取今天的问题
    getQues() {
      dayQues().then((res) => {
        if (res.data.answerResult) {
          this.dtStatus = 3
          this.dtjd = 3
          this.ddts = res.data.answerResult.correctCount
          return
        }
        this.dtStatus = 0
        const rawQuestions = res.data.questions;
        // 转换数据格式
        this.quesList = rawQuestions.map(item => {
          // 1. 初始化选项对象，默认值为空字符串
          const optionsMap = { A: '', B: '', C: '', D: '' };
          let correctKey = '';

          // 2. 遍历 qoption 数组，填充选项并找出正确答案
          item.qoption.forEach(opt => {
            // 根据 qsort (1-4) 映射到 A-D
            const keyMap = ['A', 'B', 'C', 'D'];
            const key = keyMap[opt.qsort - 1];

            if (key) {
              optionsMap[key] = opt.qoption;
            }

            // 记录正确答案的键名 (A/B/C/D)
            if (opt.qisRight) {
              correctKey = key;
            }
          });

          // 3. 返回符合组件要求的新对象
          return {
            qid: item.qid,
            ques: item.qname,
            ...optionsMap, // 展开 A, B, C, D
            correct: correctKey,
            analy: item.qexplain,
            quesShow: true, // 初始显示题目
            dtjg: null      // 初始未答题
          };
        });
        // this.quesList = res.data.data
      });
    },
    // 点击答案选项
    answerClick(val) {
      if (this.quesList[this.dtjd - 1].dtjg) {
        return
      }

      if (val == this.quesList[this.dtjd - 1].correct) {
        this.ddts += 1
      }

      var obj = { ...this.quesList[this.dtjd - 1] }
      obj.dtjg = val
      this.$set(this.quesList, this.dtjd - 1, obj)
    },
    // 点击答案之后赋值class
    getQueClass(val, type) {
      if (type) {
        if (this.quesList[this.dtjd - 1].dtjg) {
          if (this.quesList[this.dtjd - 1].dtjg == val) {
            if (this.quesList[this.dtjd - 1].dtjg == this.quesList[this.dtjd - 1].correct) {
              return 'checked'
            } else {
              return 'clear'
            }
          } else {
            if (val == this.quesList[this.dtjd - 1].correct) {
              return 'checked'
            }
          }
        }
        return
      }
      if (this.quesList[this.dtjd - 1].dtjg) {
        if (this.quesList[this.dtjd - 1].dtjg == val) {
          if (this.quesList[this.dtjd - 1].dtjg == this.quesList[this.dtjd - 1].correct) {
            return 'an-item-right'
          } else {
            return 'an-item-wrong'
          }
        } else {
          if (val == this.quesList[this.dtjd - 1].correct) {
            return 'an-item-right'
          }
        }
      }
    },

    // 答题提交
    dtSubmit() {
      var answers = this.quesList.map(item => {
        return { qid: item.qid, userAnswer: item.dtjg }
      })
      this.$toast.loading({ message: '提交中...', forbidClick: true, duration: 0 });
      ansSubmit({ answers: answers }).then((res) => {
        this.$toast.clear();
        if (res.code == 0) {
          this.dtStatus = 2
          this.dtAllright = res.data.isAllCorrect
          if (res.data.isAllCorrect) {
            let obj = this.hzList.find(item => {
              return item.code == res.data.badgeName
            })
            this.dtjl.points = res.data.points
            this.dtjl.hzimg = obj.img
            this.dtjl.hzname = obj.name
            this.dtjl.proname = obj.proname
            this.dtjl.prodesc = obj.prodesc
            this.dtjl.proimg = obj.proimg
            this.dtjl.proprice = obj.proprice
            this.resultPopupShow = true
          }

        } else {
          this.$toast.fail(res.msg);
        }

      });

      // this.resultPopupShow = true
    },
    // 运动打卡提交
    ljdkFn() {
      // this.jkStatus = 1
      // this.resultPopupShow = true

      if(this.jkchose == 0){
        var ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
            // ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
            wx.miniProgram.getEnv((res) => {
                if (res.miniprogram) {
                    console.log("在小程序里");
                    wx.miniProgram.navigateTo({
                        url: '/pages/countSteps/home/index',
                        success: (res) => { console.log('成功') },
                        fail: (res) => { console.log('失败') },
                        complete: (res) => { console.log('完成') },
                    })
                } else {
                    console.log("不在小程序里");
                    this.$toast.fail('请在微信小程序中打开');
                }
            })
        } else {
            console.log('不在微信里');
                    this.$toast.fail('请在微信小程序中打开');
        }
      }
    },




    getuserPoints() {
      userPoints().then(res => {
        this.chances = res.data.chances
        this.points = res.data.points
        this.dailyBlessingSy = res.data.dailyBlessingSy
        this.allZf = res.data.allZf

        if (localStorage.getItem('lovenum')) {
          this.totalAx = res.data.totalAx - 1
          setTimeout(() => { this.showgif = true }, 100)
          setTimeout(() => {
            this.showgif = false
            this.totalAx = res.data.totalAx
            localStorage.removeItem('lovenum')
          }, 2000)
        } else {
          this.totalAx = res.data.totalAx
        }
      })
    },


    dlFn() {
      this.$refs.commonComponent.scrollFn()
    },

  },

  beforeDestroy() {
  },
}
</script>

<style lang="less" scoped>
.container {
  padding: 9px 0 0px 0;
  background: linear-gradient(180deg, #8833EF 0%, #B675F8 50.86%, #ECCAFA 100%);

  display: flex;
  flex-direction: column;
  align-items: center;


  .top {
    width: 100%;
    padding: 8px 14px 15px 20px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;

    .li {
      width: 82px;
      height: 26px;
      padding-left: 22px;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(245, 230, 255, 0.37);
      box-shadow: inset 0px 0px 16px 13px rgba(255, 255, 255, 0.5);
      border-radius: 16px 16px 16px 16px;
      border: 1px solid rgba(255, 255, 255, 0.6);
      position: relative;
      font-weight: 500;
      font-size: 16px;
      color: #6935A3;


      .icon {
        width: 40px;
        height: 40px;
        top: -10px;
        left: -8px;
        position: absolute;
      }
    }
  }

  .fdkh {
    width: 232px;
  }

  .fdkhtime {
    margin-top: 5px;
    width: 300px;
  }

  .tabs {
    margin-top: 16px;
    display: flex;
    padding: 4px;
    background: rgba(255, 255, 255, 0.76);
    border-radius: 10px;

    .tab {
      padding: 4px 21px;
      border-radius: 10px;

      .textimg {
        width: 112px;
        margin-top: 4px;
      }
    }

    .tabactive {
      background: #fff;
    }
  }

  .jkzsbox {
    margin-top: 16px;
    width: 346px;
    height: 540px;
    background-image: url(../assets/img2/venuetwo-jkzs-bg.png);
    background-size: 100% 100%;

    .jkzs-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 30px;
      padding: 15px 20px 25px 20px;
      // border: 1px solid red;
      font-family: Alibaba PuHuiTi 3.0, Alibaba PuHuiTi 30;
      font-weight: normal;
      font-size: 17px;
      color: #AE6300;

      .span1 {
        font-weight: bold;
        font-size: 24x;
      }

      .span2 {
        font-size: 13px;
      }
    }

    .content {
      height: calc(100% - 70px);
      padding: 0 9px 8px;

      .beginbox {
        padding: 65px 20px 0 23px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .jkzsdttitle {
          width: 147px;
        }

        .tips {
          width: 100%;
          margin: 40px 0 55px 0;
          font-family: Alibaba PuHuiTi 3.0, Alibaba PuHuiTi 30;
          font-weight: normal;
          font-size: 16px;
          color: #515151;

          .text {
            margin: 7px 0;
          }
        }

        .btn {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 158px;
          height: 38px;
          background: linear-gradient(0deg, #FFC466 0%, #FD8F00 100%);
          border-radius: 29px 29px 29px 29px;
          font-weight: 500;
          font-size: 16px;
          color: #FFFFFF;
        }
      }

      .quesbox {
        width: 100%;
        height: 100%;
        background-color: #fff;
        border-radius: 5px 5px 15px 15px;
        padding: 0 14px;
        box-sizing: border-box;

        .ques {
          height: 75px;
          padding: 0 5px;
          box-sizing: border-box;
          border-bottom: 1px solid #D1D1D6;
          font-family: Alibaba PuHuiTi 3.0, Alibaba PuHuiTi 30;
          font-weight: normal;
          font-size: 18px;
          color: #403F3F;
          display: flex;
          align-items: center;
        }

        .answerbox {
          height: 320px;
          padding: 30px 0;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .an-item {
            width: 100%;
            padding: 9px 10px 9px 25px;
            box-sizing: border-box;
            background: #F7F7F7;
            border: 1px solid #F7F7F7;
            border-radius: 30px;
            font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
            font-weight: 400;
            font-size: 16px;
            color: #555555;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .opt {
              max-width: calc(100% - 24px);
            }

            .icon {
              font-size: 20px;
            }
          }

          .an-item-right {
            background: #D9FF93;
            border: 1px solid #7DC413;
            color: #4B7D00;
          }

          .an-item-wrong {
            background: #FFDDDD;
            border: 1px solid #EA5858;
            color: #DD2020;
          }
        }

        .answerbtn {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
          font-weight: 500;
          font-size: 16px;

          .btn {
            border-radius: 29px 29px 29px 29px;
            display: flex;
            justify-content: center;
            align-items: center;
            box-sizing: content-box;
          }

          .btn1 {
            width: 123px;
            height: 34px;
            color: #FD8F00;
            border: 1.5px solid #FD8F00;
          }

          .btn2 {
            width: 158px;
            height: 38px;
            color: #FFFFFF;
            background: linear-gradient(0deg, #FFC466 0%, #FD8F00 100%);
          }
        }

        .analybox {
          font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
          color: #555555;

          .analybox-con {
            min-height: 246px;
            max-height: 330px;
            overflow-y: scroll;

            .text1 {
              margin: 18px 0 4px 0;
              font-weight: 500;
              font-size: 18px;
            }

            .text2 {
              font-weight: 400;
              font-size: 16px;
              text-align: justify;

              span {
                font-weight: 500;
                color: #FF8412;
              }
            }
          }


          .back {
            width: 294px;
            height: 38px;
            background: linear-gradient(0deg, #FFC466 0%, #FD8F00 100%);
            border-radius: 29px 29px 29px 29px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
            font-weight: 500;
            font-size: 16px;
            color: #FFFFFF;
          }
        }
      }

      .resultbox {
        .title {
          font-family: HelloFont WenYiHei, HelloFont WenYiHei;
          font-weight: 400;
          font-size: 18px;
          color: #F08800;
          text-align: center;
        }

        .priceitem {
          display: flex;
          margin: 30px 0 39px 0;

          .item {
            width: 108px;
            height: 108px;
            background: #FFF7B4;
            border-radius: 14px 14px 14px 14px;
            font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
            font-weight: bold;
            font-size: 16px;
            color: #FF9F30;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin: 0 15px;

            .icon {
              width: 52px;
              height: 52px;
              margin-bottom: 7px;
            }
          }
        }

        .wzjicon {
          width: 100px;
          height: 100px;
        }

        .titlewzj {
          margin: 27px 0 55px 0;
        }
      }

      .endbox {
        .tips {
          margin: 72px 0 90px 0;
          text-align: center;
        }

        .btn {
          display: flex;
          justify-content: center;
          align-items: center;
          font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
          font-weight: 500;
          font-size: 16px;
          color: #FFFFFF;
          background: linear-gradient(0deg, #C8C8C8 0%, #A2A2A2 100%);
        }
      }
    }
  }

  .jkxwbox {

    .jkxw-top {
      width: 343px;
      height: 65px;
      padding: 16px 0 0 10px;
      box-sizing: border-box;
      background-image: url(../assets/img2/venuetwo-jkzsxw-topbg.png);
      background-size: 100% 100%;
      margin-top: 4px;

      .line1 {
        display: flex;
        align-items: center;

        .des {
          font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
          font-weight: 500;
          font-size: 12px;
          color: #1F1F1F;
          margin: 0 5px;

          span {
            font-weight: bold;
            font-size: 17px;
            color: #FB9F1D;
            margin: 0 2px;
          }
        }

        .icon {
          width: 11px;
          height: 4.5px;
          margin-top: 4px;
        }
      }

      .line2 {
        display: flex;
        align-items: center;
        font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
        font-weight: 400;
        font-size: 12px;
        color: #757575;
        margin-top: 4px;
        padding-left: 3px;

        .date {
          margin-right: 10px;
        }

        .icon {
          width: 11px;
          height: 11px;
          margin-top: 1px;
        }

        .week {
          color: #404040;
          margin: 0 3px;
        }
      }
    }

    .clockbox {
      width: 100%;
      background: #fff;
      padding: 25px 10px 17px 10px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      border-radius: 0 0 10px 10px;

      .clockitem {
        width: 42px;
        height: 53px;
        border: 1px solid #F8F7FC;
        background: #F8F7FC;
        border-radius: 8px 8px 8px 8px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-weight: 500;
        font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
        position: relative;

        .jl {
          position: absolute;
          top: -19px;
          left: -5px;
          background: linear-gradient(270deg, #FECC36 0%, #FE9230 100%);
          border-radius: 5px;
          padding: 0 3px 1px 3px;
          font-weight: 500;
          font-size: 9px;
          color: #FFFFFF;
          white-space: nowrap;

          &::after {
            content: '';
            position: absolute;
            bottom: -3px;
            /* 根据三角形高度调整，使其尖角向下延伸 */
            left: 50%;
            transform: translateX(-50%);
            width: 0;
            height: 0;
            border-left: 4px solid transparent;
            border-right: 4px solid transparent;
            border-top: 4px solid #FEAF33;
          }
        }

        .jl2 {
          left: -7px;
        }

        .date {
          font-size: 18px;
          color: #2E2D33;
        }

        .week {
          font-size: 10px;
          color: #9F9F9F;
          margin-top: 1px;
        }

        .gift {
          width: 22px;
          height: 22px;
        }
      }

      .clockitemddk {
        background: #FFFDC7;
        border: 1px solid #FFB34E;

        .week {
          color: #FF9E30;
          margin-top: 3px;
        }
      }

      .clockitemseven {
        .week {
          margin-top: 4px;
        }
      }
    }

    .dkbox {
      width: 100%;
      border-radius: 10px 10px 10px 10px;
      background: linear-gradient(180deg, #FFF6BF 0%, #FFFFFF 21.07%);
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 25px 0 40px 0;
      margin-top: 12px;

      .jkxwtitle {
        width: 314px;
        margin-bottom: 20px;
      }

      .dkitem {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 306px;
        height: 67px;
        background: #DEFBD3;
        border-radius: 7px 7px 7px 7px;
        margin-bottom: 12px;

        .icon {
          width: 41px;
          height: 41px;
          margin-right: 10px;
        }

        .name {
          font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
          font-weight: 500;
          font-size: 14px;
          color: #2E2D33;
          width: 210px;
        }

        .check {
          font-size: 18px;
          color: #FFB34E;
          ;
        }

        .nocheck {
          font-size: 18px;
          color: #696969;
        }
      }

      .dkitem2 {
        background: #D7EEFF;
      }

      .dkitem3 {
        background: #FFEEBD;
      }

      .btn {
        width: 306px;
        height: 40px;
        margin-top: 15px;
        background: linear-gradient(180deg, #FFC466 0%, #FD8F00 100%);
        border-radius: 30px 30px 30px 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
        font-weight: 500;
        font-size: 16px;
        color: #FFFFFF;
      }

      .btnno {
        background: linear-gradient(180deg, #C8C8C8 0%, #A2A2A2 100%);
      }
    }
  }

}
</style>
